import { CONFIGS, CURRENT_MODE } from "../config/appConfig";

export const DEBUG_PREFILL_PARTICIPANT_CODE = "DEBUG002";

export function normalizeParticipantCode(value) {
  return String(value || "").trim().toUpperCase().replace(/\s/g, "");
}

export function isDebugPrefillParticipantCode(value) {
  return normalizeParticipantCode(value) === DEBUG_PREFILL_PARTICIPANT_CODE;
}

export function getDebugStartingQuestionnaireData({ participantCode, assignedMode } = {}) {
  return {
    participantCode: normalizeParticipantCode(participantCode) || DEBUG_PREFILL_PARTICIPANT_CODE,
    assignedMode: assignedMode || CURRENT_MODE || CONFIGS.MODE_5,
    ageGroup: "25-34",
    gender: "Prefer not to say",
    profession: "Student",
    ati: {
      occupyDetail: "4",
      testFunctions: "4",
      dealBecauseMust: "3",
      tryIntensively: "4",
      enjoyAcquainting: "4",
      enoughWorks: "3",
      understandHow: "4",
      enoughBasic: "3",
      fullCapabilities: "4",
    },
    englishProficiency: {
      listening: "5",
      reading: "5",
      spokenInteraction: "4",
      spokenProduction: "4",
      writing: "4",
    },
    tipi: {
      extraverted: "4",
      critical: "3",
      dependable: "5",
      anxious: "2",
      openToExperiences: "5",
      reserved: "3",
      sympathetic: "5",
      disorganised: "2",
      calm: "5",
      conventional: "3",
    },
  };
}

export function getDebugAfterImageQuestionnaireData() {
  return {
    captionQuality: "4",
  };
}

export function getDebugAfterPhaseQuestionnaireData() {
  return {
    tpa: {
      deceptive: "2",
      underhanded: "2",
      suspicious: "2",
      wary: "3",
      harmful: "1",
      confident: "5",
      security: "5",
      integrity: "5",
      dependable: "5",
      reliable: "5",
      trust: "5",
      familiar: "4",
    },
  };
}

export function getDebugEndingQuestionnaireData() {
  return {
    sus: {
      frequentUse: "4",
      complex: "2",
      easyUse: "4",
      needSupport: "2",
      wellIntegrated: "4",
      inconsistent: "2",
      quickLearn: "4",
      cumbersome: "2",
      confident: "4",
      needLearning: "2",
    },
    trustThinking: "Debug: I focused on whether the explanations matched the highlighted concepts and evidence.",
    photobookUsefulness: "Debug: Yes, this would be useful for checking and organizing holiday captions.",
    systemImprovements: "Debug: Faster evidence previews and clearer explanation summaries would help.",
    additionalComments: "Debug: Prefilled test run for DEBUG002.",
  };
}